import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function UpdateCoatTypeFormContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Name}>Name</FormLabel>
        <FormInput
          name={Input.Name}
          placeholder="e.g. Short, Long, Curly..."
        />
      </FormFieldGroup>
    </div>
  )
}
